// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../index';

export const LoginResponseFailureFragmentDoc = `
    fragment loginResponseFailure on LoginResponseFailure {
  __typename
  code
  message(locale: $locale)
}
    `;